module.exports = __webpack_public_path__ + "img/card-mastercard.a05125bc.svg";